module.exports = __webpack_public_path__ + "img/RedWhiteHalf.ab2ed063.jpg";